module.exports = [
  require('./elder_brain'),
  require('./enchanter'),
  require('./evoker'),
]
